import { TextureInfo } from '../model/texture-info';

export class TextureInfoManager {
	private textures: Map<string, TextureInfo> = new Map();

	addTexture(key: string, info: TextureInfo): void {
		this.textures.set(key, info);
	}

	getTexture(key: string): TextureInfo | null {
		return this.textures.get(key) || null;
	}

	getAllTextures(): TextureInfo[] {
		return Array.from(this.textures.values());
	}
}

